import { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";

const FormTienda = ({
  date,
  tiendas,
  setDate,
  setTiendas,
  dataTiendas,
  setDataTiendas,
  setError,
}) => {
  const [tienda, setTienda] = useState("");
  const [validTienda, setValidTienda] = useState(false);

  useEffect(() => {
    setValidTienda(validarTienda(tienda));
  }, [tienda]);

  const onChangeDate = (e) => {
    //console.log(e.target.value)
    setDate(e.target.value);
  };
  const onChangeTienda = (e) => {
    //console.log(e.target.value)
    setTienda(e.target.value);
  };
  const onAgregarTienda = (e) => {
    //console.log(e.target.value)
    e.preventDefault();
    setTiendas([...tiendas, `2${tienda}`]);
    setTienda("");
  };
  const onLimpiar = (e) => {
    e.preventDefault();
    console.log("Limpiar");
    setTienda("");
    setTiendas([]);
    setDate("");
    setDataTiendas([]);
    setError(false);
  };
  const validarTienda = (tienda) => {
    const re = /^[0-9\b]+$/;
    if (tienda.length === 3 && re.test(tienda)) {
      return true;
    } else {
      return false;
    }
  };
  return (
    <div>
      <Form className="p-2">
        <Form.Group className="mb-3" controlId="formBasicPassword">
          <Form.Label>Fecha:</Form.Label>
          <Form.Control
            value={date}
            type="date"
            onChange={onChangeDate}
            disabled={dataTiendas?.length > 0 ? true : false}
          />
          {!date && (
            <h6 className="text-center text-danger opacity-75 small">
              Favor de Seleccionar primero la fecha
            </h6>
          )}
        </Form.Group>
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Form.Label>Tienda:</Form.Label>
          <div className="d-flex gap-1">
            <span className="fs-5">T0</span>
            <Form.Control
              value={tienda}
              type="text"
              placeholder="NNN"
              onChange={onChangeTienda}
              disabled={date === "" || dataTiendas?.length > 0 ? true : false}
            />
          </div>
          {date !== "" && !validTienda && dataTiendas?.length === 0 && (
            <h6 className="text-center text-danger opacity-75 small">
              Favor de ingresar una tienda válida
            </h6>
          )}
        </Form.Group>

        <div className="d-flex justify-content-center gap-2">
          <button
            disabled={!validTienda || date === "" ? true : false}
            className="btn btn-outline-info"
            type="button"
            onClick={onAgregarTienda}
          >
            Agregar
          </button>
          <button
            className="btn btn-outline-danger"
            type="button"
            onClick={onLimpiar}
          >
            Limpiar
          </button>
        </div>
      </Form>
    </div>
  );
};

export default FormTienda;
